// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"60548eb7","305":"7ee5018e","499":"62507c66","686":"60d0742a","755":"38f89ff0"}[chunkId] + ".chunk.js";
};